<template>
  <canvas ref="chart"></canvas>
</template>

<script lang="ts">
import PieChart, {PieChartDataSet} from '@/components/charts/PieChart';
import {defineComponent, onMounted, PropType, ref} from 'vue';

export default defineComponent({
    props: {
        dataset: {
            type: Object as PropType<PieChartDataSet>,
            required: true,
        },
        labels: {
            type: Array as PropType<string[]>,
            required: true,
        },
    },
    setup(props) {
        const chart = ref<HTMLCanvasElement | null>(null);

        let pieChart: PieChart;

        onMounted(() => {
            pieChart = new PieChart(
                chart.value as HTMLCanvasElement,
                props.dataset,
                props.labels,
            );
        });

        return {chart};
    },
});
</script>
